import Icon from "@/components/icon";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";

type SmallProps = {
  show: Content.PodcastShow;
};

const Small = (props: SmallProps) => {
  const image = props.show.fields.image;
  return (
    <Link href={`/poddar/${props.show.fields.slug}`} className="group block">
      {image && (
        <div className="relative mb-2">
          <div className="aspect-w-1 aspect-h-1">
            <Image
              fill
              src={createImageUrl(image.fields.file?.url!, { crop: "1:1" })}
              alt={image.fields.alt || ""}
              className="object-cover"
              sizes={createImageSizes({
                mobile: "12vw",
                tablet: "12vw",
                desktop: "12vw",
              })}
            />
          </div>
          <div className="bg-white-500 absolute bottom-0 right-0 z-10 p-2 pl-0 flex before:w-4 before:h-full before:absolute before:top-0 before:-skew-x-[12deg] before:-translate-x-1/2 before:bg-white-500">
            <Icon.Logo className="fill-gray-500 h-3 w-auto z-10" />
            <Icon.Podcast className="fill-purple-500 h-3 w-auto z-10 ml-1" />
          </div>
        </div>
      )}
      {props.show.fields.title && (
        <TeaserHeading
          text={props.show.fields.title}
          className="text-2xl font-semibold"
        />
      )}
    </Link>
  );
};

export default Small;
